import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import authReducer from "./containers/auth/authSlice";
import loginPageReducer from "./pages/auth/login/login.slice";
import modalxReducer from "components/modalx/modalx.slice";
import ordersReducer from "containers/orders/orders.slice";

const reducer = combineReducers({
  authReducer,
  loginPageReducer,
  modalxReducer,
  ordersReducer
});

const store = configureStore({ reducer });

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
